export const CREDIT = 2;
export const INVOICE = 1;
export const PAYMENT_PROVIDER = 3;

export const paymentTypes = {
  [CREDIT]: 'credit',
  [INVOICE]: 'invoice'
}
